module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-500italic.woff2?2fa39b3957f9546871ce490ebc0ff531";